import { useState } from "react";
import { faqItems } from "@/mocks/faq";
import ScrollReveal from "@/components/base/ScrollReveal";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="relative w-full py-20 md:py-28 bg-background-50 overflow-hidden">
      <div className="relative w-full px-4 sm:px-6 md:px-10 lg:px-16 max-w-3xl mx-auto">
        <ScrollReveal className="text-center mb-14">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 mb-4">
            Tire suas dúvidas
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            Perguntas{" "}
            <span className="text-primary-600">Frequentes</span>
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base md:text-lg">
            Respostas para as principais dúvidas sobre nossos produtos e serviços.
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.1} staggerChildren staggerDelay={0.06}>
          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className={`rounded-xl border transition-all duration-400 ${
                  openIndex === idx
                    ? "bg-background-100 border-primary-300/50"
                    : "bg-background-50/80 border-background-200/40 hover:border-background-300/60"
                }`}
              >
                <button
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-950">
                    {item.question}
                  </span>
                  <span
                    className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-400 ${
                      openIndex === idx
                        ? "bg-primary-500 text-background-50 rotate-180"
                        : "bg-background-200 text-foreground-600 group-hover:bg-background-300"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === idx ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-5 pb-5 md:px-6 md:pb-6 text-sm md:text-base text-foreground-700 leading-relaxed">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}